import {
  CheckInDetailsRequest,
  ConfirmCheckInRequest,
} from "@/central-atoms/everest-fleet-pwa/requests";
import {
  CheckInDetailsResponse,
  CheckInHistoryResponse,
  ConfirmCheckInDetailsResponse,
} from "@/central-atoms/everest-fleet-pwa/responses";
import { API_BASE_URL } from "@/constants";
import { apiClient } from "../apiClient";

class CheckInService {
  static async getCheckInDetails(
    reqBody: any
  ): Promise<CheckInDetailsResponse> {
    const response = await apiClient.post(
      `${API_BASE_URL}/check_in_details`,
      reqBody
    );
    return response.data;
  }

  static async confirmCheckIn(
    reqBody: ConfirmCheckInRequest
  ): Promise<ConfirmCheckInDetailsResponse> {
    const response = await apiClient.post(
      `${API_BASE_URL}/confirm_check_in`,
      reqBody
    );
    return response.data;
  }

  static async getCheckInHistory(
    hub: string,
    page: number,
    per_page: number,
    recent: number = 0
  ): Promise<CheckInHistoryResponse> {
    const response = await apiClient.get(`${API_BASE_URL}/check_in_history`, {
      params: {
        recent,
        hub,
        page,
        per_page,
      },
    });
    return response.data;
  }
}

export default CheckInService;
